const paginateTable = function () {
  const perfSwitchAttr = "data-js-perf-switch";
  const perfSwitchEls = document.querySelectorAll(`[${perfSwitchAttr}]`);

  perfSwitchEls.forEach((perfSwitchEl) => {
    const responsiveTableEl = perfSwitchEl.querySelector(".timetable__table > .table-responsive");

    const weekEls = perfSwitchEl.querySelectorAll(`[${perfSwitchAttr}-week]`);
    const groups = [...weekEls]
      .map((weekEl) => weekEl.getAttribute(`${perfSwitchAttr}-week`))
      .filter((val, i, arr) => arr.indexOf(val) === i);

    const total = groups.length;
    let firstPerformanceWeek = null;

    const prevBtnEl = perfSwitchEl.querySelector(`[${perfSwitchAttr}-prev]`);
    const nextBtnEl = perfSwitchEl.querySelector(`[${perfSwitchAttr}-next]`);

    const jumpForwardBtnEls = perfSwitchEl.querySelectorAll(`[${perfSwitchAttr}-jump-forward]`);

    const scrollToFirstPerformance = () => {
      const nearestBtnEl = perfSwitchEl.querySelector(
        `[${perfSwitchAttr}-week="${State.currentIndex}"] button`,
      );
      if (responsiveTableEl && nearestBtnEl) {
        const btnRect = nearestBtnEl.getBoundingClientRect();
        const containerRect = responsiveTableEl.getBoundingClientRect();
        const btnOffsetLeft = btnRect.left - containerRect.left;
        const scrollPosition = btnOffsetLeft - containerRect.width / 2 + btnRect.width / 2;

        responsiveTableEl.scroll({
          left: scrollPosition,
          behavior: "smooth",
        });
      }
    };

    250;

    const State = {
      currentIndex: 1,
      paginate: function (count) {
        const newCurrentIndex = State.currentIndex + count;
        if (newCurrentIndex > total) return null;
        if (newCurrentIndex < 1) return null;
        State.update({ currentIndex: newCurrentIndex });
      },
      update: function (props) {
        if (props) {
          Object.keys(props).forEach((key) => {
            if (key in this) {
              this[key] = props[key];
            }
          });
        }

        const isFirstWeek = State.currentIndex === 1;
        const isLastWeek = State.currentIndex === total;

        weekEls.forEach((weekEl) => {
          const attrVal = weekEl.getAttribute(`${perfSwitchAttr}-week`);
          const matches = parseInt(attrVal) === State.currentIndex;

          weekEl.style.display = matches ? null : "none";
        });

        if (prevBtnEl) {
          prevBtnEl.disabled = isFirstWeek;
        }
        if (nextBtnEl) {
          nextBtnEl.disabled = isLastWeek;
        }
        jumpForwardBtnEls.forEach((jumpForwardBtnEl) => {
          const attrVal = jumpForwardBtnEl.getAttribute(`${perfSwitchAttr}-jump-forward`);
          jumpForwardBtnEl.style.display = State.currentIndex >= parseInt(attrVal) ? "none" : "";
        });
      },
      init: function () {
        State.update();
      },
    };

    if (prevBtnEl) {
      prevBtnEl.addEventListener("click", () => {
        State.paginate(-1);
        scrollToFirstPerformance();
      });
    }
    if (nextBtnEl) {
      nextBtnEl.addEventListener("click", () => {
        State.paginate(1);
        scrollToFirstPerformance();
      });
    }

    jumpForwardBtnEls.forEach((jumpForwardBtnEl) => {
      jumpForwardBtnEl.addEventListener("click", () => {
        const attrVal = jumpForwardBtnEl.getAttribute(`${perfSwitchAttr}-jump-forward`);
        State.update({ currentIndex: parseInt(attrVal) });
        scrollToFirstPerformance();
      });
    });

    State.init();
  });
};

try {
  paginateTable();
  window.addEventListener("filmfilter_apply_filters_finished", () => {
    paginateTable();
  });
} catch (error) {
  console.error(error);
}
